import { useNavigate } from 'react-router-dom';
import NewsSlider from '../../Components/LandingPage/NewSlider';
import Section from '../../Components/UI/Section';
import NewsCard from '../../Components/LandingPage/NewsCard';
import EventCard from '../../Components/LandingPage/EventCard';
import BenefitCard from '../../Components/LandingPage/BenefitCard';
import { FaFacebook, FaYoutube, FaTwitter } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { getPublicPublications, getPublicEvents } from '../../API/getters';

// Importando as imagens do slider
import s1 from '../../assets/SLider/s1.jpeg';
import s2 from '../../assets/SLider/s2.jpeg';
import s3 from '../../assets/SLider/s3.jpeg';
import s4 from '../../assets/SLider/s4.jpeg';
import s5 from '../../assets/SLider/s5.jpeg';
import s6 from '../../assets/SLider/s6.jpeg';
import s8 from '../../assets/SLider/s8.jpg';

const LandingPage = () => {
    const navigate = useNavigate();
    const [publications, setPublications] = useState([]);
    const [events, setEvents] = useState([]);
    const [currentNewsPage, setCurrentNewsPage] = useState(0);
    const [currentEventsPage, setCurrentEventsPage] = useState(0);

    useEffect(() => {
        const fetchPublications = async () => {
            const publications = await getPublicPublications();
            console.log("Fetched publications:", publications);
            setPublications(publications);
        };

        const fetchEvents = async () => {
            const events = await getPublicEvents();
            setEvents(events);
            console.log("Fetched events:", events);
        }
        fetchPublications();
        fetchEvents();
    }, [])

    const handleEventClick = (evento) => {
        navigate(`/eventos/${evento.uuid}`);
    };
    
    const sliderItems = [
        {
            id: 1,
            title: "Bem-Vindo à Plataforma Alumni da Universidade Eduardo Mondlane!",
            description: "A Comunidade Alumni – UEM é um espaço privilegiado de congregação de várias gerações de graduados da UEM. Ela permite a partilha e o conhecimento do perfil profissional de cada graduado, mas também a possibilidade de uma interação mais próxima com a UEM.",
            image: s1
        },
        {
            id: 2,
            title: "Conecte-se aos Graduados de Todas as Gerações",
            description: "Faça parte de uma rede de mais de 50 mil graduados que compartilham experiências, conhecimentos e oportunidades profissionais.",
            image: s2
        },
        {
            id: 3,
            title: "Tenha Acesso a Oportunidades de Carreira e Desenvolvimento",
            description: "Aceda a vagas exclusivas, participe em workshops e mantenha-se actualizado sobre tendências do mercado de trabalho.",
            image: s3
        },
        {
            id: 4,
            title: "Eventos Exclusivos para a Comunidade Alumni",
            description: "Participe em encontros, palestras e eventos de networking que aproximam graduados e fortalecem a comunidade.",
            image: s4
        },
        {
            id: 5,
            title: "Contribua para o Desenvolvimento da UEM",
            description: "Seja um agente de transformação, participe em projectos e iniciativas que impactam positivamente a universidade e a sociedade.",
            image: s5
        },
        {
            id: 6,
            title: "Mantenha-se Conectado com a UEM",
            description: "Receba informações actualizadas sobre a universidade, cursos, pesquisas e oportunidades de formação contínua.",
            image: s6
        },
        {
            id: 8,
            title: "Aceda a Recursos Educacionais Exclusivos",
            description: "Tenha acesso a materiais didácticos, bibliotecas digitais e cursos online.",
            image: s8
        }
    ];

    const newsItems = publications;
    const eventosItems = events;
    
    // Configurações do slider de notícias
    const NEWS_PER_PAGE = 3;
    const totalNewsPages = Math.ceil(newsItems.length / NEWS_PER_PAGE);
    
    const nextNewsPage = () => {
        setCurrentNewsPage((prev) => (prev + 1) % totalNewsPages);
    };
    
    const prevNewsPage = () => {
        setCurrentNewsPage((prev) => (prev - 1 + totalNewsPages) % totalNewsPages);
    };
    
    const currentNews = newsItems.slice(
        currentNewsPage * NEWS_PER_PAGE,
        (currentNewsPage + 1) * NEWS_PER_PAGE
    );
    
    // Configurações do slider de eventos
    const EVENTS_PER_PAGE = 3;
    const totalEventsPages = Math.ceil(eventosItems.length / EVENTS_PER_PAGE);
    
    const nextEventsPage = () => {
        setCurrentEventsPage((prev) => (prev + 1) % totalEventsPages);
    };
    
    const prevEventsPage = () => {
        setCurrentEventsPage((prev) => (prev - 1 + totalEventsPages) % totalEventsPages);
    };
    
    const currentEvents = eventosItems.slice(
        currentEventsPage * EVENTS_PER_PAGE,
        (currentEventsPage + 1) * EVENTS_PER_PAGE
    );

    // Auto-play dos sliders
    useEffect(() => {
        const newsInterval = setInterval(() => {
            if (totalNewsPages > 1) {
                nextNewsPage();
            }
        }, 5000);
        
        const eventsInterval = setInterval(() => {
            if (totalEventsPages > 1) {
                nextEventsPage();
            }
        }, 5000);
        
        return () => {
            clearInterval(newsInterval);
            clearInterval(eventsInterval);
        };
    }, [totalNewsPages, totalEventsPages]);

    return (
        <div className="w-full">
            
            {/* Hero / Slider */}
            <div className="mt-6">
                <NewsSlider news={sliderItems} />
            </div>

            {/* Benefits Section */}
            <Section
                title="Por que fazer parte da comunidade Alumni?"
                background="white"
                titleClassName="text-center pt-6"
            >
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[
                        { id: 1, title: 'Networking Profissional', description: 'Conecte-se com colegas e potenciais empregadores.' },
                        { id: 2, title: 'Empregabilidade', description: 'Aceda vagas e faça parte de estudos de empregabilidade.' },
                        { id: 3, title: 'Formação Contínua', description: 'Participe de eventos e workshops especializados.' },
                    ].map((b) => (
                        <BenefitCard key={b.id} title={b.title} description={b.description} />
                    ))}
                </div>
            </Section>

            {/* News Section - Slider com 3 colunas */}
            <Section title="Últimas Notícias" background="white">
                <div className="relative">
                    {/* Botão Anterior */}
                    {totalNewsPages > 1 && (
                        <button
                            onClick={prevNewsPage}
                            className="absolute -left-4 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-2 hover:bg-emerald-50 transition-colors"
                        >
                            <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                    )}
                    
                    {/* Grid de Notícias */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {currentNews.map((noticia) => (
                            <div key={noticia.uuid} className="transition-transform duration-300 hover:-translate-y-1">
                                <NewsCard
                                    image={noticia.image}
                                    title={noticia.title}
                                    excerpt={noticia.description}
                                    date={noticia.date}
                                    onReadMore={() => navigate(`/feed/${noticia.uuid}`)}
                                />
                            </div>
                        ))}
                    </div>
                    
                    {/* Botão Próximo */}
                    {totalNewsPages > 1 && (
                        <button
                            onClick={nextNewsPage}
                            className="absolute -right-4 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-2 hover:bg-emerald-50 transition-colors"
                        >
                            <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    )}
                    
                    {/* Indicadores de Página */}
                    {totalNewsPages > 1 && (
                        <div className="flex justify-center gap-2 mt-6">
                            {Array.from({ length: totalNewsPages }).map((_, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => setCurrentNewsPage(idx)}
                                    className={`h-2 rounded-full transition-all duration-300 ${
                                        currentNewsPage === idx 
                                            ? 'w-6 bg-emerald-600' 
                                            : 'w-2 bg-gray-300 hover:bg-emerald-400'
                                    }`}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </Section>

            {/* Events Section - Slider com 3 colunas */}
            <Section title="Próximos Eventos" background="white">
                <div className="relative">
                    {/* Botão Anterior */}
                    {totalEventsPages > 1 && (
                        <button
                            onClick={prevEventsPage}
                            className="absolute -left-4 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-2 hover:bg-emerald-50 transition-colors"
                        >
                            <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                    )}
                    
                    {/* Grid de Eventos */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {currentEvents.map((evento, idx) => (
                            <EventCard
                                key={evento.uuid}
                                date={evento.date}
                                title={evento.title}
                                location={evento.location || ''}
                                description={evento.about}
                                onDetails={() => handleEventClick(evento)}
                                alternate={idx % 2 === 0}
                            />
                        ))}
                    </div>
                    
                    {/* Botão Próximo */}
                    {totalEventsPages > 1 && (
                        <button
                            onClick={nextEventsPage}
                            className="absolute -right-4 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg p-2 hover:bg-emerald-50 transition-colors"
                        >
                            <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    )}
                    
                    {/* Indicadores de Página */}
                    {totalEventsPages > 1 && (
                        <div className="flex justify-center gap-2 mt-6">
                            {Array.from({ length: totalEventsPages }).map((_, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => setCurrentEventsPage(idx)}
                                    className={`h-2 rounded-full transition-all duration-300 ${
                                        currentEventsPage === idx 
                                            ? 'w-6 bg-emerald-600' 
                                            : 'w-2 bg-gray-300 hover:bg-emerald-400'
                                    }`}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </Section>

            {/* Footer Section */}
            <footer className="px-8 md:px-12 mt-12 pt-12 pb-6 border-t border-gray-200 bg-gradient-to-r from-emerald-50 to-gray-50">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
                        <div>
                            <h3 className="text-lg font-medium text-gray-800 mb-4">Sobre o Alumni</h3>
                            <p className="text-gray-500 text-sm leading-relaxed text-justify">
                                A Comunidade Alumni – UEM é um espaço privilegiado de congregação de várias gerações de graduados da UEM. 
                                Ela permite a partilha e o conhecimento do perfil profissional de cada graduado, mas também a possibilidade 
                                de uma interação mais próxima com a UEM.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-800 mb-4">Links Rápidos</h3>
                            <ul className="space-y-2">
                                <li><a href="/feed" className="text-gray-500 hover:text-emerald-600 transition-colors text-sm">Feed</a></li>
                                <li><a href="/eventos" className="text-gray-500 hover:text-emerald-600 transition-colors text-sm">Eventos</a></li>
                                <li><a href="/vagas" className="text-gray-500 hover:text-emerald-600 transition-colors text-sm">Vagas</a></li>
                                <li><a href="/parceiros" className="text-gray-500 hover:text-emerald-600 transition-colors text-sm">Parceiros</a></li>
                                <li><a href="https://docs.google.com/forms/d/e/1FAIpQLScAsdfxE5E4kbRW3NtoFy0QoyHQkqdOzvqNrt69w_p7Rkzmsg/viewform" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-emerald-600 transition-colors text-sm">Inscrição</a></li>
                                <li><a href="/contacte-nos" className="text-gray-500 hover:text-emerald-600 transition-colors text-sm">Contacte-nos</a></li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-800 mb-4">Contacto</h3>
                            <ul className="space-y-2 text-gray-500 text-sm">
                                <li>Campus Universitário Principal</li>
                                <li>Av. Julius Nyerere, nr. 3453</li>
                                <li>Maputo – Moçambique</li>
                                <li>Direcção do Registo Académico</li>
                                <li>Fax: +258 21475311</li>
                                <li>Telefone: +258 21478100</li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-800 mb-4">Redes Sociais</h3>
                            <div className="flex space-x-4">
                                <a 
                                    href="https://web.facebook.com/uem.neen" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-emerald-50 hover:text-emerald-600 transition-all duration-200"
                                >
                                    <FaFacebook size={18} />
                                </a>
                                <a 
                                    href="https://www.facebook.com/uemmoc" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-emerald-50 hover:text-emerald-600 transition-all duration-200"
                                >
                                    <FaYoutube size={18} />
                                </a>
                                <a 
                                    href="https://twitter.com/uem_moc" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-emerald-50 hover:text-emerald-600 transition-all duration-200"
                                >
                                    <FaTwitter size={18} />
                                </a>
                            </div>
                            <div className="mt-4">
                                <p className="text-xs text-gray-400">
                                    Siga-nos nas redes sociais para acompanhar todas as novidades.
                                </p>
                            </div>
                        </div>
                    </div>
                    
                   
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;